import { number, object } from "yup";

const RateInteractionSchema = object({
  clinic_experience: number()
    .required("required")
    .min(1, "required")
    .max(5, "must be between 1 - 5"),
  practitioner: number()
    .required("required")
    .min(1, "required")
    .max(5, "must be between 1 - 5"),
  chw: number()
    .required("required")
    .min(1, "required")
    .max(5, "must be between 1 - 5"),
  environment: number()
    .required("required")
    .min(1, "required")
    .max(5, "must be between 1 - 5"),
  collecting_prescription: number()
    .required("required")
    .min(1, "required")
    .max(5, "must be between 1 - 5"),
  waiting_time: number()
    .required("required")
    .min(1, "required")
    .max(5, "must be between 1 - 5"),
});

export const rateInteractionInitialValues = {
  clinic_experience: 0,
  practitioner: 0,
  chw: 0,
  environment: 0,
  collecting_prescription: 0,
  waiting_time: 0,
};

export default RateInteractionSchema;
